export const PORTFOLIO_ITEM_REQUEST = 'iron/portfolios/PORTFOLIO_ITEM_REQUEST';
export const PORTFOLIO_ITEM_SUCCESS = 'iron/portfolios/PORTFOLIO_ITEM_SUCCESS';
export const PORTFOLIO_ITEM_FAIL = 'iron/portfolios/PORTFOLIO_ITEM_FAIL';

export const portfolioItemRequest = (chainId, params, marketName = null) => ({
  type: PORTFOLIO_ITEM_REQUEST,
  payload: { chainId, params, marketName },
});

export const portfolioItemSuccess = (payload) => ({
  type: PORTFOLIO_ITEM_SUCCESS,
  payload,
});

export const portfolioItemFail = (payload) => ({
  type: PORTFOLIO_ITEM_FAIL,
  payload,
});
